import React from "react";
import {SearchResultTableWithUpdateUI} from "../Common/SearchResultTableWithUpdateUI";
import {View} from "../GenGenPlate/Enum";
import {gppApiConsts} from "./GppApiConsts";
import {GppTableDataApi} from "./GppTableDataApi";
import {WesternBlotForm} from "./WesternBlotForm";

interface WesternBlotSearchResultTableState {}

interface WesternBlotSearchResultTableProps {
    keywords: string
    comparator: string
    refreshToken: string
    view: View
}

export class WesternBlotSearchResultTable extends React.Component<WesternBlotSearchResultTableProps, WesternBlotSearchResultTableState> {
    static defaultProps = {
        refreshToken: "",
        keywords: "",
    }

    render() {
        return <SearchResultTableWithUpdateUI
            refreshToken={this.props.refreshToken}
            databaseName={gppApiConsts.DATABASE_NAME}
            tableName={"western_blot"}
            keywords={this.props.keywords}
            columns={""}
            operator={this.props.comparator}
            keyField={"id"}
            legends={<></>}
            title={this.props.view === View.Update ?  "" : "Western Blot"}
            modalForm={WesternBlotForm}
            rowClasses={() => ""}
            columnsHidden={[]}
            columnsDisplayInOrder={[
                "owner", "plasmidId", "plateId", "cellLine", "gene", "quantificationScore", "guideSequence", "guideDescription", "id"
            ]}
            view={this.props.view}
            enableFilter={this.props.view === View.Update}
            searchTable={GppTableDataApi.searchTable}
        />
    }
}